import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found — Riverstone Partners" description="The page you're looking for doesn't exist." path="/404" />
      <section className="flex min-h-[70vh] items-center bg-ivory py-24">
        <div className="shell text-center">
          <p className="eyebrow text-river">404</p>
          <h1 className="mt-4 font-serif text-4xl font-light tracking-tight text-navy sm:text-5xl">
            This path leads somewhere else.
          </h1>
          <p className="mx-auto mt-4 max-w-md text-charcoal/70">
            The page you’re looking for doesn’t exist or has moved. Let’s get you back
            on solid ground.
          </p>
          <Link to="/" className="btn-primary mt-8" data-testid="notfound-home-link">
            Back to Home
          </Link>
        </div>
      </section>
    </>
  );
}
